import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BaasicTable, EmptyState } from "core/components";
import { ApplicationListLayout, Content } from "core/layouts";

function ProductHistoryListTemplate({ productHistoryListViewStore }) {
    const {
        tableStore,
        routes,
        authorization
    } = productHistoryListViewStore;

    return (
        <ApplicationListLayout
            store={productHistoryListViewStore}
            authorization={authorization}
        >
            <Content emptyRenderer={renderEmpty(routes)}>
                <div className="card--table">
                    <BaasicTable
                        authorization={authorization}
                        tableStore={tableStore}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    );
}

function renderEmpty(routes) {
    return (
        <EmptyState
            title="FACILITY_HISTORY.LIST.EMPTY_STATE.TITLE"
            callToAction={routes.create}
        />
    );
}

ProductHistoryListTemplate.propTypes = {
    productHistoryListViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(ProductHistoryListTemplate);